import script from "./limitReminder.vue?vue&type=script&setup=true&lang=ts&MinusCircleOutlined=true&name=limitReminder"
export * from "./limitReminder.vue?vue&type=script&setup=true&lang=ts&MinusCircleOutlined=true&name=limitReminder"

import "./limitReminder.vue?vue&type=style&index=0&id=6baed96e&lang=scss"

const __exports__ = script;

export default __exports__